import { getConfig } from '@b2ag/micro-front-tools'

export function buildCallerId(): string {
  const prefix = 'front'
  const frontContext = getConfig('CONTEXT_APP') // agri - tech
  const appBrand = getConfig('APP_CONTEXT') // aladin - farmi

  return [prefix, frontContext, appBrand].filter(Boolean).join('-')
}
